<template>
  <memlist-card>
    <m-row>
      <m-col lg="12">
        <h3 class="mt-2" style="color: #444444;">Antal grupper: {{ count }}</h3>
      </m-col>
    </m-row>
  </memlist-card>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardCompanyCountCard',
  components: {

  },
  props: ['period_id'],
  data() {
    return {
      count: 0,
    };
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId','isAuthenticated','settings']),
  },
  mounted() {
    this.load_count();
  },
  watch: {
    currentCompanyId() {
    
    },
    currentPeriodId(newValue, oldValue) {
      
    }
  },
  methods: {
    
    async load_count() {
      const res = await axios.get(`/company/publiclist`);

      if (res.status === 200) {
        this.count = res.data.length;
      }
    },

  }
};
</script>